"use client";
import * as React from "react";
const SvgExternalRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 9.778v4.444C16 15.2 15.2 16 14.222 16H1.778C.8 16 0 15.2 0 14.222V1.778C0 .8.8 0 1.778 0h4.444c.49 0 .89.4.89.889s-.4.889-.89.889H2.667c-.49 0-.89.4-.89.889v10.666c0 .49.4.89.89.89h10.666c.49 0 .89-.4.89-.89V9.778c0-.49.4-.89.888-.89.489 0 .889.4.889.89Zm-8.489-2.56a.885.885 0 0 0 0 1.253c.347.338.916.347 1.253 0l5.45-5.449v2.374c0 .488.4.888.888.888.49 0 .89-.4.89-.888V.889a.878.878 0 0 0-.88-.889h-4.516c-.49 0-.89.4-.89.889s.4.889.89.889h2.364L7.511 7.227v-.01Z" }));
export {
  SvgExternalRound as default
};
